const provinceSigle = {
    "AGRIGENTO": "AG",
    "ALESSANDRIA": "AL",
    "ANCONA": "AN",
    "AOSTA": "AO",
    "AREZZO": "AR",
    "ASCOLI PICENO": "AP",
    "ASTI": "AT",
    "AVELLINO": "AV",
    "BARI": "BA",
    "BELLUNO": "BL",
    "BENEVENTO": "BN",
    "BERGAMO": "BG",
    "BIELLA": "BI",
    "BOLOGNA": "BO",
    "BOLZANO": "BZ",
    "BRESCIA": "BS",
    "BRINDISI": "BR",
    "CAGLIARI": "CA",
    "CALTANISSETTA": "CL",
    "CAMPOBASSO": "CB",
    "CASERTA": "CE",
    "CATANIA": "CT",
    "CATANZARO": "CZ",
    "CHIETI": "CH",
    "COMO": "CO",
    "COSENZA": "CS",
    "CREMONA": "CR",
    "CROTONE": "KR",
    "CUNEO": "CN",
    "ENNA": "EN",
    "FERRARA": "FE",
    "FIRENZE": "FI",
    "FOGGIA": "FG",
    "FORLI": "FO",
    "FROSINONE": "FR",
    "GENOVA": "GE",
    "GORIZIA": "GO",
    "GROSSETO": "GR",
    "IMPERIA": "IM",
    "ISERNIA": "IS",
    "LA SPEZIA": "SP",
    "L'AQUILA": "AQ",
    "LATINA": "LT",
    "LECCE": "LE",
    "LECCO": "LC",
    "LIVORNO": "LI",
    "LODI": "LO",
    "LUCCA": "LU",
    "MACERATA": "MC",
    "MANTOVA": "MN",
    "MASSA": "MS",
    "MATERA": "MT",
    "MESSINA": "ME",
    "MILANO": "MI",
    "MODENA": "MO",
    "NAPOLI": "NA",
    "NOVARA": "NO",
    "NUORO": "NU",
    "ORISTANO": "OR",
    "PADOVA": "PD",
    "PALERMO": "PA",
    "PARMA": "PR",
    "PAVIA": "PV",
    "PERUGIA": "PG",
    "PESARO": "PS",
    "PESCARA": "PE",
    "PIACENZA": "PC",
    "PISA": "PI",
    "PISTOIA": "PT",
    "PORDENONE": "PN",
    "POTENZA": "PZ",
    "PRATO": "PO",
    "RAGUSA": "RG",
    "RAVENNA": "RA",
    "REGGIO CALABRIA": "RC",
    "REGGIO EMILIA": "RE",
    "RIETI": "RI",
    "RIMINI": "RN",
    "ROMA": "RM",
    "ROVIGO": "RO",
    "SALERNO": "SA",
    "SASSARI": "SS",
    "SAVONA": "SV",
    "SIENA": "SI",
    "SIRACUSA": "SR",
    "SONDRIO": "SO",
    "TARANTO": "TA",
    "TERAMO": "TE",
    "TERNI": "TR",
    "TORINO": "TO",
    "TRAPANI": "TP",
    "TRENTO": "TN",
    "TREVISO": "TV",
    "TRIESTE": "TS",
    "UDINE": "UD",
    "VARESE": "VA",
    "VENEZIA": "VE",
    "VERBANIA": "VB",
    "VERCELLI": "VC",
    "VERONA": "VR",
    "VIBO VALENTIA": "VV",
    "VICENZA": "VI",
    "VITERBO": "VT"
};

export default provinceSigle;
  